import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { IProps } from "./types";
import { translateVoices } from "./utils";
import messages from "./messages";

const WanterVoices = ({ voices }: IProps) => {
    const { formatMessage } = useIntl();
    if (voices.length === 0) return null;
    let voicesText = '';
    const translatedVoices = translateVoices(voices);
    if (voices.length === 1) {
        voicesText = translatedVoices[0];
    } else if (voices.length === 2) {
        voicesText = translatedVoices.join(` ${formatMessage(messages.and)} `);
    } else {
        voicesText = translatedVoices.slice(0, -1).join(", ") + ` ${formatMessage(messages.and)} ${translatedVoices[translatedVoices.length - 1]}`;
    }
    return (
        <p style={{ fontWeight: 600 }}>
            <FormattedMessage {...messages.voicesWanted} values={{ voices: voicesText }}/>
        </p>
    )
};

export default WanterVoices;
